// extracted by mini-css-extract-plugin
export default {"observer":"InternetObserver_observer__QUoj5"};